// @deprecated Import from the api directory instead:
// `src/react/shared/api/load/useOnLoad`. Forwarder retained so the existing
// importers keep working until they migrate to the api directory.
import useOnLoad from '../../shared/api/load/useOnLoad';

export default useOnLoad;
